import React, {
    useState,
    useEffect
}
from "react";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";


export default function HomeBox(props)
{
    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const delay =
        props.delay || 0;

    const [title, setTitle] =
        useState("");

    const [icon, setIcon] =
        useState("");

    const [color, setColor] =
        useState("");

    const [isLive, setIsLive] =
        useState(false);

    const [displayOpacity, setDisplayOpacity] =
        useState("1");

    const [iconColor, setIconColor] =
        useState("white");

    const [ready, setReady] =
        useState(false);

    const [isHover, setIsHover] =
        useState(false);


    //--------------------------------------------------------
    // Props
    //--------------------------------------------------------

    useEffect(
        function()
        {
            setTitle(
                props.title
            );

            setIcon(
                props.icon
            );

            setColor(
                props.color
            );

            setIsLive(
                props.isLive
            );
        },
        [props]
    );


    //--------------------------------------------------------
    // Entrance delay
    //--------------------------------------------------------

    useEffect(
        function()
        {
            const timer =
                setTimeout(
                    function()
                    {
                        setReady(
                            true
                        );
                    },
                    delay
                );

            return function()
            {
                clearTimeout(
                    timer
                );
            };
        },
        [delay]
    );


    //========================================================
    // Container
    //========================================================

    const thisContainer =
    {
        position:
            "relative",

        display:
            "flex",

        flexDirection:
            props.isMobile
                ?
                "column"
                :
                "row",

        width:
            "calc(100% - 20px)",

        margin:
            "10px",

        marginTop:
            "15px",

        //----------------------------------------------------
        // Soft outer card
        //----------------------------------------------------

        borderRadius:
            "6px",

        background:
            "rgba(255,255,255,0.82)",

        backdropFilter:
            "blur(10px)",

        WebkitBackdropFilter:
            "blur(10px)",

        border:
            "1px solid rgba(7,28,49,0.10)",

			boxShadow:

			    props.isMobile

			        ?

			        "0 2px 5px rgba(7,28,49,0.08), 0 7px 16px rgba(7,28,49,0.10)"

			        :

			        "0 2px 5px rgba(7,28,49,0.08), 0 10px 28px rgba(7,28,49,0.13)",

        alignItems:
            "stretch",

        boxSizing:
            "border-box",

        overflow:
            "visible",

        opacity:
            ready
                ?
                1
                :
                0,

        transform:
            ready
                ?
                "translateY(0px)"
                :
                "translateY(14px)",

        transition:
            "opacity 0.6s ease, transform 0.6s ease"
    };


    //========================================================
    // Desktop left side
    //========================================================

    const leftWrapper =
    {
        position:
            "relative",

        //----------------------------------------------------
        // Slightly wider to give puck breathing room
        //----------------------------------------------------

        width:
            "54px",

        flexShrink:
            0
    };

	//========================================================
	// Square charcoal icon puck
	// Blue on hover
	//========================================================

	const iconPuck =
	{

	    position:
	        "absolute",

	    //----------------------------------------------------
	    // Inset from outer card
	    //----------------------------------------------------

	    top:
	        "6px",

	    left:
	        "6px",

	    width:
	        "42px",

	    height:
	        "42px",

	    borderRadius:
	        "0px",

	    display:
	        "flex",

	    alignItems:
	        "center",

	    justifyContent:
	        "center",

	    flexDirection:
	        "column",

	    //----------------------------------------------------
	    // Charcoal normally / OmniScan blue on hover
	    //----------------------------------------------------

	    background:

	        isHover

	            ?

	            "linear-gradient(180deg, #52c9f3 0%, #20afe8 52%, #0786bd 100%)"

	            :

	            "linear-gradient(180deg, #292d31 0%, #15181b 100%)",

	    border:
	        "none",

	    boxShadow:

	        isHover

	            ?

	            `
	            0 7px 18px rgba(32,175,232,0.30),
	            0 3px 8px rgba(7,28,49,0.20),
	            inset 0 1px 0 rgba(255,255,255,0.28)
	            `

	            :

	            `
	            0 3px 10px rgba(0,0,0,0.18),
	            inset 0 1px 0 rgba(255,255,255,0.10)
	            `,

	    overflow:
	        "hidden",

	    transition:
	        "background 0.22s ease, box-shadow 0.22s ease, transform 0.22s ease",

	    transform:

	        isHover

	            ?

	            "translateY(-1px)"

	            :

	            "translateY(0px)",

	    cursor:

	        isLive === false

	            ?

	            "not-allowed"

	            :

	            (

	                isLive === true

	                    ?

	                    "pointer"

	                    :

	                    "default"

	            ),

	    zIndex:
	        3

	};
	
	
	
	//========================================================
	// Hover title tab
	//
	// Slides out from underneath the icon puck.
	//========================================================
	const hoverTitle =
	{
	    position:
	        "absolute",

	    top:
	        "6px",

	    left:
	        "27px",

	    height:
	        "42px",

	    minWidth:
	        "115px",

	    paddingLeft:
	        "28px",

	    paddingRight:
	        "14px",

	    display:
	        "flex",

	    alignItems:
	        "center",

	    boxSizing:
	        "border-box",

	    background:
	        "linear-gradient(180deg, #52c9f3 0%, #20afe8 52%, #0786bd 100%)",

	    color:
	        "#ffffff",

	    fontSize:
	        "11px",

	    fontWeight:
	        "600",

	    letterSpacing:
	        "0.2px",

	    whiteSpace:
	        "nowrap",

	    borderRadius:
	        "0px",

	    boxShadow:
	        "0 5px 14px rgba(7,28,49,0.18)",

	    opacity:
	        isHover
	            ?
	            1
	            :
	            0,

	    transform:
	        isHover
	            ?
	            "translateX(0px)"
	            :
	            "translateX(-95px)",

	    transition:
	        "transform 0.24s ease, opacity 0.16s ease",

	    pointerEvents:
	        "none",

	    zIndex:
	        2
	};


    //--------------------------------------------------------
    // White icon
    //--------------------------------------------------------

    const iconStyle =
    {
        color:
            "#ffffff",

        width:
            "18px",

        height:
            "18px",

        opacity:
            displayOpacity,

        position:
            "relative",

        zIndex:
            2,

        filter:
            "drop-shadow(0 1px 2px rgba(0,0,0,0.30))"
    };


    //========================================================
    // Desktop text rail
    //========================================================

    const textRail =
    {
        position:
            "absolute",

        //----------------------------------------------------
        // Starts immediately beneath inset puck
        //----------------------------------------------------

        top:
            "48px",

        //----------------------------------------------------
        // Centre underneath 42px puck:
        // 6px left inset + 21px centre - 1px rail
        //----------------------------------------------------

        left:
            "26px",

        width:
            "2px",

        height:
            "calc(100% - 48px)",

        //----------------------------------------------------
        // Charcoal rail
        //----------------------------------------------------

        background:
            "rgba(30,34,38,0.48)",

        borderRadius:
            "0px",

        border:
            "none",

        boxShadow:
            "none",

        padding:
            "0px",

        display:
            "block"
    };


    const titleStyle =
    {
        writingMode:
            "vertical-rl",

        transform:
            "rotate(180deg)",

        fontSize:
            "9px",

        color:
            "rgba(255,255,255,0.88)",

        letterSpacing:
            "1px",

        fontWeight:
            "600",

        opacity:
            0
    };


    //========================================================
    // Mobile header
    //========================================================

    const mobileHeader =
    {
        position:
            "relative",

        display:
            "flex",

        alignItems:
            "center",

        width:
            "100%",

        height:
            "42px",

        minHeight:
            "42px",

        paddingLeft:
            "54px",

        paddingRight:
            "14px",

        boxSizing:
            "border-box",

        //----------------------------------------------------
        // Charcoal mobile header
        //----------------------------------------------------

        background:
            "linear-gradient(180deg, #292d31 0%, #15181b 100%)",

        borderRadius:
            "0px",

        overflow:
            "hidden",

        cursor:
            isLive
                ?
                "pointer"
                :
                "default"
    };


    //--------------------------------------------------------
    // Mobile puck
    //
    // Deliberately reset to 0 / 0 because on mobile this is
    // part of the header rather than a floating card control.
    //--------------------------------------------------------

    const mobilePuck =
    {
        ...iconPuck,

        top:
            "0px",

        left:
            "0px",

        boxShadow:
            "none",

        borderRight:
            "1px solid rgba(255,255,255,0.10)"
    };


    const mobileTitle =
    {
        fontSize:
            "12px",

        fontWeight:
            "600",

        color:
            "#ffffff",

        letterSpacing:
            "0.2px",

        lineHeight:
            "42px"
    };


    //========================================================
    // Right / content side
    //========================================================

    const rightContainer =
    {
        display:
            "flex",

        width:
            props.isMobile
                ?
                "100%"
                :
                "calc(100% - 54px)",

        flexDirection:
            "column",

        //----------------------------------------------------
        // Inner content remains sharp
        //----------------------------------------------------

        borderRadius:
            "0px",

        overflow:
            "hidden",

        minWidth:
            0
    };


    const mainContent =
    {
        display:
            "flex",

        width:
            "100%",

        height:
            "100%",

        pointerEvents:
            isLive
                ?
                "none"
                :
                "auto",

        transition:
            "filter 0.2s ease, opacity 0.2s ease"
    };


    //========================================================
    // Events
    //========================================================

    const handleClick =
        function()
        {
            if(
                isLive === true
                &&
                props.clickFunction
            )
            {
                props.clickFunction();
            }
        };


    const handleMouseEnter =
        function()
        {
            if(isLive)
            {
                setIsHover(
                    true
                );
            }
        };


    const handleMouseLeave =
        function()
        {
            setIsHover(
                false
            );
        };


    //========================================================
    // Render
    //========================================================

    return (
        <div style={thisContainer}>


            {/* ==============================================
                MOBILE HEADER
            ============================================== */}

            {
                props.isMobile
                &&
                <div
                    style={mobileHeader}
                    onClick={
                        handleClick
                    }
                    onMouseEnter={
                        handleMouseEnter
                    }
                    onMouseLeave={
                        handleMouseLeave
                    }
                >

                    <div style={mobilePuck}>

                        <FontAwesomeIcon
                            icon={icon}
                            style={iconStyle}
                        />

                    </div>


                    <div style={mobileTitle}>

                        {title}

                    </div>

                </div>
            }


            {/* ==============================================
                DESKTOP LEFT RAIL
            ============================================== */}

            {
                !props.isMobile
                &&
                <div style={leftWrapper}
				onMouseEnter={
                    handleMouseEnter
                }
                onMouseLeave={
                    handleMouseLeave
                }
				>

				{/* --------------------------------------
				       Sliding title tab
				   --------------------------------------- */}

				   <div style={hoverTitle}>
				       {title}
				   </div>

                    {/* --------------------------------------
                        Charcoal icon block
                    --------------------------------------- */}

                    <div
                        style={iconPuck}
                        onClick={
                            handleClick
                        }
                        
                    >

                        <FontAwesomeIcon
                            icon={icon}
                            style={iconStyle}
                        />

                    </div>


                    {/* --------------------------------------
                        Charcoal title rail
                    --------------------------------------- */}

                    <div style={textRail}>

                        <div style={titleStyle}>

                            {title}

                        </div>

                    </div>

                </div>
            }


            {/* ==============================================
                CONTENT
            ============================================== */}

            <div style={rightContainer}>

                <div style={mainContent}>

                    {props.children}

                </div>

            </div>

        </div>
    );
}